import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Features } from "@/components/Features";
import { Requirements } from "@/components/Requirements";
import { Setup } from "@/components/Setup";
import { Community } from "@/components/Community";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";
import { useLenis } from "@/lib/useLenis";

export default function Landing() {
  useLenis();
  return (
    <main className="bg-[#050505] text-[#F5F5F5]" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Features />
      <Requirements />
      <Setup />
      <Community />
      <FinalCta />
      <Footer />
    </main>
  );
}
